<template>
  <div class="time-interval-picker">
    <time-picker
      v-bind:items="timeSetForFrom"
      v-model="from"
      v-bind:disabled="disabled"
    />
    —
    <time-picker
      v-bind:items="timeSetForTo"
      v-model="to"
      v-bind:disabled="disabled"
    />
  </div>
</template>

<script>
import TimePicker from '@/components/TimePicker.vue';

/**
 * @description Создать набор времени (чч:мм) интервала по времени.
 * @param {string} initialTime Опорное время.
 * @returns {string[]}
 */
const makeTimeSetByTime = (initialTime) => {
  const initialHour = Number(initialTime.slice(0, 2));
  const acc = [];
  const minHour = initialHour - 2;
  const maxHour = initialHour + 2;
  for (let hour = minHour; hour <= maxHour; hour += 1) {
    const time = hour < 10 ? `0${hour}:00` : `${hour}:00`;
    acc.push(time);
  }
  return acc;
};

/**
 * Компонент выбора временного интервала с автодополнением и селектором
 * @type {Vue}
 */
export default {
  name: 'TimeIntervalPicker',
  components: { TimePicker },
  computed: {
    timeSetForFrom() {
      if (this.timeSet.length) {
        return this.timeSet;
      }
      return makeTimeSetByTime(this.from);
    },
    timeSetForTo() {
      if (this.timeSet.length) {
        return this.timeSet;
      }
      return makeTimeSetByTime(this.to);
    },
  },
  data() {
    return {
      selectedFrom: false,
      selectedTo: false,
      from: this.initialFrom,
      to: this.initialTo,
    };
  },
  watch: {
    from() {
      this.$emit('input-from', this.from);
    },
    to() {
      this.$emit('input-to', this.to);
    },
  },
  props: {
    /**
     * @description Деактивировать.
     * @type {boolean}
     */
    disabled: {
      type: Boolean,
      default: () => false,
    },
    /**
     * @description Время начала.
     * @type {string}
     */
    initialFrom: {
      required: true,
      type: String,
    },
    /**
     * @description Время окончания.
     * @type {string}
     */
    initialTo: {
      required: true,
      type: String,
    },
    /**
     * @description Предлагаемый набор часов.
     * @type {string[]}
     */
    timeSet: {
      default: () => [],
      required: false,
      type: Array,
    },
  },
};
</script>
